module.exports = __webpack_public_path__ + "static/media/acelszerkezetes-csarnok-kivitelezes-debrecen.2496a3a0.jpg";